export default "__VITE_ASSET__7bpCB8R4__"